// ============================================================
// LEPSIM FASHION TAROT
// start → loading → result（6種／カードはランダム抽選）
// ============================================================

const IMG = './assets/images/';

// ============================================================
// カードデータ（テキスト・リンクは支給待ち。構造のみ確定）
// ============================================================
const cards = [
	{
		id: 'magician',
		nameEn: 'THE MAGICIAN',
		bg: '#f9f1c8',
		card: IMG + 'card/1.webp',
		fortune: '今日のあなたは、新しいオシャレのアイデアが次々と湧き出てくるマジシャン！\nいつもと同じ服でも、組み合わせを変えたり\n小物をプラスするだけで、\nガラリと新鮮なスタイルが作れそう。',
		stylingImg: IMG + 'styling/1.webp',
		stylingTxt: '定番のボーダーＴにワーク調のロングスカートを合わせた、手持ち服の印象をがらりと変える「クローゼットマジック」なスタイリング。腰巻きしたチェックシャツでメリハリをプラス。',
		stylingLink: 'https://www.dot-st.com/lepsim/disp/itemlist/?dispNo=002100709', // アプリ用: adastriaapp://items?dispNo=0000100004_002100709&orderBy=00
		items: [
			{ label: 'tops', price: '¥4,400', link: 'https://www.dot-st.com/lepsim/disp/item/840077/?COLOR_CD=08' },
			{ label: 'shirt', price: '¥5,990', link: 'https://www.dot-st.com/lepsim/disp/item/1052101/?COLOR_CD=75' },
			{ label: 'skirt', price: '¥6,990', link: 'https://www.dot-st.com/lepsim/disp/item/888829/?COLOR_CD=52' },
			{ label: 'shoes', price: '¥6,990', link: 'https://www.dot-st.com/lepsim/disp/item/1042668/?COLOR_CD=09' },
			{ label: 'bag', price: '¥6,990', link: 'https://www.dot-st.com/lepsim/disp/item/1049413/?COLOR_CD=09' },
			{ label: 'cap', price: '¥5,060', link: 'https://www.dot-st.com/lepsim/disp/item/1023762/?COLOR_CD=78' },
		],
	},
	{
		id: 'empress',
		nameEn: 'THE EMPRESS',
		bg: '#e6c8be',
		card: IMG + 'card/2.webp',
		fortune: '今日のあなたは、周囲の視線を集める、\n愛され運が最高潮の一日！\n身に纏うだけでレディな気分になれる\n上品なアイテムがキーになるはず。',
		stylingImg: IMG + 'styling/2.webp',
		stylingTxt: '異素材MIXで魅せる上品カジュアル。カジュアルなデニムシャツに、レースやとろみ感のあるサテンスカートを合わせることで、ラフになりすぎずフェミニンなテイストを取り入れたミックススタイル。',
		stylingLink: 'https://www.dot-st.com/lepsim/disp/itemlist/?dispNo=002100710', // アプリ用: adastriaapp://items?dispNo=0000100004_002100710&orderBy=00
		items: [
			{ label: 'shirt', price: '¥7,700', link: 'https://www.dot-st.com/lepsim/disp/item/1046465/?COLOR_CD=85' },
			{ label: 'skirt', price: '¥5,990', link: 'https://www.dot-st.com/lepsim/disp/item/1049485/?COLOR_CD=08' },
			{ label: 'sandal', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/1049222/?COLOR_CD=15' },
			{ label: 'bag', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/910573/?COLOR_CD=09' },
		],
	},
	{
		id: 'lovers',
		nameEn: 'THE LOVERS',
		bg: '#dccad2',
		card: IMG + 'card/3.webp',
		fortune: '今日のあなたは、ときめくモノや人との\n出会いがあるハッピーな日！\n身につけるだけで気分が上がるアイテムを\n身に纏ってお出かけしましょう。\n迷った時は、理屈より直感で！',
		stylingImg: IMG + 'styling/3.webp',
		stylingTxt: '着るだけで気分の上がる、今季の「ときめきマストバイ」アイテムであるクロシェ風ニットベストが主役のスタイリング。アーキのワイドパンツを合わせて、甘さを抑えた大人カジュアルに仕上げています。',
		stylingLink: 'https://www.dot-st.com/lepsim/disp/itemlist/?dispNo=002100711', // アプリ用: adastriaapp://items?dispNo=0000100004_002100711&orderBy=00
		items: [
			{ label: 'vest', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/1049616/?COLOR_CD=08' },
			{ label: 'pants', price: '¥5,990', link: 'https://www.dot-st.com/lepsim/disp/item/878963/?COLOR_CD=77' },
			{ label: 'shoes', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/1049230/?COLOR_CD=09' },
			{ label: 'bag', price: '¥4,990', link: 'https://www.dot-st.com/lepsim/disp/item/1049426/?COLOR_CD=09' },
		],
	},
	{
		id: 'star',
		nameEn: 'THE STAR',
		bg: '#dee6e4',
		card: IMG + 'card/4.webp',
		fortune: '今日のあなたは、隠れた才能や、内に秘めた\n美しさにスポットライトが当たる日！\n「着てみたい」と思っていた憧れのスタイルに、今日こそ挑戦してみては？\n理想の自分に、一歩近づけるチャンス！',
		stylingImg: IMG + 'styling/4.webp',
		stylingTxt: '温かみのある手仕事と現代的な洗練を融合させた「モダンクラフト」スタイル。刺繍やスタッズの効いたデニムにフリンジベルトを重ね、クラフト感あふれるボヘミアンニュアンスを演出。',
		stylingLink: 'https://www.dot-st.com/lepsim/disp/itemlist/?dispNo=002100713', // アプリ用: adastriaapp://items?dispNo=0000100004_002100713&orderBy=00
		items: [
			{ label: 'tops', price: '¥3,990', link: 'https://www.dot-st.com/lepsim/disp/item/839453/?COLOR_CD=58' },
			{ label: 'pants', price: '¥11,000', link: 'https://www.dot-st.com/lepsim/disp/item/879120/?COLOR_CD=880' },
			{ label: 'scarf', price: '¥3,300', link: 'https://www.dot-st.com/lepsim/disp/item/1053609/?COLOR_CD=55' },
			{ label: 'shoes', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/1049230/?COLOR_CD=09' },
		],
	},
	{
		id: 'sun',
		nameEn: 'THE SUN',
		bg: '#f1d7be',
		card: IMG + 'card/5.webp',
		fortune: '今日のあなたは、エネルギー満タン！\n太陽のようなまぶしい笑顔で、\n周囲まで明るくハッピーにしてしまう\n最高にアクティブな一日！\nフットワーク軽く動ける服装が◎',
		stylingImg: IMG + 'styling/5.webp',
		stylingTxt: '温かみのある手仕事と現代的な洗練を融合させた「モダンクラフト」スタイル。刺繍やスタッズの効いたデニムにフリンジベルトを重ね、クラフト感あるボヘミアンニュアンスを演出。',
		stylingLink: 'https://www.dot-st.com/lepsim/disp/itemlist/?dispNo=002100712', // アプリ用: adastriaapp://items?dispNo=0000100004_002100712&orderBy=00
		items: [
			{ label: 'tops', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/840060/?COLOR_CD=88' },
			{ label: 'pants', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/879068/?COLOR_CD=118' },
			{ label: 'shoes', price: '¥5,990', link: 'https://www.dot-st.com/lepsim/disp/item/1042669/?COLOR_CD=82' },
			{ label: 'bag', price: '¥3,300', link: 'https://www.dot-st.com/lepsim/disp/item/805733/?COLOR_CD=09' },
		],
	},
	{
		id: 'world',
		nameEn: 'THE WORLD',
		bg: '#d4dcd4',
		card: IMG + 'card/6.webp',
		fortune: '今日のあなたは、すべてのバランスが美しく、文句なしにパーフェクトな大吉日！\n何をやってもうまくいく無敵の運気なので、\n大切な予定を入れたり、\n特別な場所へ出かけたりするのに最適。',
		stylingImg: IMG + 'styling/6.webp',
		stylingTxt: '存在感のあるブラックデニムシャツにチェック柄シャツを重ね、こなれたレイヤードを魅せる「主役級トータルコーデ」。ウォッシュの効いたストレートデニムのラインでこなれ感を演出し、洗練された大人カジュアルに仕上がっています。',
		stylingLink: 'https://www.dot-st.com/lepsim/disp/itemlist/?dispNo=002100714', // アプリ用: adastriaapp://items?dispNo=0000100004_002100714&orderBy=00
		items: [
			{ label: 'shirt', price: '¥7,990', link: 'https://www.dot-st.com/lepsim/disp/item/1023546/?COLOR_CD=09' },
			{ label: 'shirt', price: '¥6,600', link: 'https://www.dot-st.com/lepsim/disp/item/1047095/?COLOR_CD=09' },
			{ label: 'cami', price: '¥5,500', link: 'https://www.dot-st.com/lepsim/disp/item/1047096/?COLOR_CD=09' },
			{ label: 'pants', price: '¥6,990', link: 'https://www.dot-st.com/lepsim/disp/item/878928/?COLOR_CD=85' },
			{ label: 'shoes', price: '¥4,990', link: 'https://www.dot-st.com/lepsim/disp/item/1042670/?COLOR_CD=58' },
			{ label: 'bag', price: '¥6,990', link: 'https://www.dot-st.com/lepsim/disp/item/1049413/?COLOR_CD=09' },
		],
	},
];

// お守り壁紙（3種からランダム）
// ※ static.dot-st.com を使う: www 配下だと配信時に webp へ変換されて保存用途に向かないため
const wallpapers = [
	'https://static.dot-st.com/static/docs/lepsim/pages/tarot/images/dl/1.jpg',
	'https://static.dot-st.com/static/docs/lepsim/pages/tarot/images/dl/2.jpg',
	'https://static.dot-st.com/static/docs/lepsim/pages/tarot/images/dl/3.jpg',
];

// ローディング表示時間（ms）※秒数は要指示
// 0.35s（待ち）＋ 0.425s × 5枚 ＝ 2.475s → 余韻をとって 2600ms
const LOADING_MS = 2600;


// ============================================================
// クリックイベント計測（GA4 / dot-st.com 共通の gtag を使用）
// gtag が無い環境（ローカル確認等）では何もしない
// ============================================================
let currentCard = null;

function sendEvent(name, params) {
	if (typeof window.gtag !== 'function') return;
	window.gtag('event', name, Object.assign({ card: currentCard ? currentCard.id : '' }, params || {}));
}

// data-ga 属性を持つ要素のクリックをまとめて拾う
document.addEventListener('click', (e) => {
	const el = e.target.closest('[data-ga]');
	if (!el) return;
	sendEvent('tarot_click', { label: el.dataset.ga, link_url: el.getAttribute('href') || '' });
});

// ============================================================
// DOM参照
// ============================================================
const secStart = document.getElementById('sec-start');
const secLoading = document.getElementById('sec-loading');
const secResult = document.getElementById('sec-result');
const sections = [secStart, secLoading, secResult];

// ============================================================
// ユーティリティ
// ============================================================
function showSection(el) {
	sections.forEach((s) => {
		s.classList.remove('is-active');
		s.querySelectorAll('.fadeInUp, .fadeIn').forEach((t) => t.classList.remove('active'));
	});
	el.classList.add('is-active');
	window.scrollTo(0, 0);
	setTimeout(() => {
		el.querySelectorAll('.fadeInUp, .fadeIn').forEach((t) => t.classList.add('active'));
	}, 50);
}

// 2枚目のフリップは画面に入ってから発動させる
function observeFlip() {
	const el = document.querySelector('.flip--d2');
	if (!el || !('IntersectionObserver' in window)) return;
	el.classList.remove('is-flipped');
	const io = new IntersectionObserver((entries) => {
		entries.forEach((e) => {
			if (!e.isIntersecting) return;
			e.target.classList.add('is-flipped');
			io.unobserve(e.target);
		});
	}, { threshold: 0.35 });
	io.observe(el);
}

function pick(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

// URLパラメータ
//   ?card=1〜6 … 結果ページを直接表示
//   ?p=loading … ローディング画面を表示（自動遷移なし・確認用）
//   ?p=start   … トップ（既定）
const PARAMS = new URLSearchParams(location.search);

function cardFromParam() {
	const n = parseInt(PARAMS.get('card'), 10);
	return n >= 1 && n <= cards.length ? cards[n - 1] : null;
}

// ============================================================
// 結果表示
// ============================================================
function renderResult(card) {
	document.getElementById('r-head').style.backgroundColor = card.bg;

	const cardImg = document.getElementById('r-card');
	cardImg.src = card.card;
	cardImg.alt = card.nameEn;

	document.getElementById('r-fortune').innerHTML = card.fortune.replace(/\n/g, '<br>');

	const stylingImg = document.getElementById('r-styling-img');
	stylingImg.src = card.stylingImg;
	stylingImg.alt = card.nameEn + ' おすすめのスタイリング';

	document.getElementById('r-styling-txt').textContent = card.stylingTxt;
	document.getElementById('r-styling-link').href = card.stylingLink;

	// 商品6点
	document.querySelectorAll('#r-items .r__item').forEach((li, i) => {
		const item = card.items[i];
		li.style.display = item ? '' : 'none'; // カードごとに点数が違う（4〜6点）
		if (!item) return;
		const a = li.querySelector('a');
		a.href = item.link;
		a.dataset.ga = 'item_' + item.label;
		li.querySelector('.r__item-name').textContent = item.label;
		li.querySelector('.r__item-price').textContent = item.price;
	});

	// お守り壁紙（3種からランダム）
	const wp = pick(wallpapers);
	document.getElementById('r-amulet-img').src = wp;
	const dl = document.getElementById('r-amulet-dl'); // ボタンはコメントアウト中
	if (dl) dl.href = wp;

	currentCard = card;
	sendEvent('tarot_result', { card_name: card.nameEn });

	// 引いた結果をURLに反映（そのままシェア・再訪で同じ結果が開く）
	const n = cards.indexOf(card) + 1;
	history.replaceState(null, '', location.pathname + '?card=' + n);

	// 仮想ページビュー：GA4の「ページとスクリーン」に ?card=1〜6 が並ぶ（設定不要）
	if (typeof window.gtag === 'function') {
		window.gtag('event', 'page_view', {
			page_location: location.href,
			page_path: location.pathname + location.search,
			page_title: 'LEPSIM FASHION TAROT - ' + card.nameEn,
		});
	}

	showSection(secResult);
	observeFlip();
}

// ============================================================
// カードを引く
// ============================================================
function draw() {
	sendEvent('tarot_start', {});
	showSection(secLoading);
	setTimeout(() => renderResult(pick(cards)), LOADING_MS);
}

// ============================================================
// イベント
// ============================================================
document.getElementById('btn-start').addEventListener('click', draw);
document.getElementById('btn-retry').addEventListener('click', () => {
	sendEvent('tarot_retry', {});
	history.replaceState(null, '', location.pathname);
	showSection(secStart);
});

// ============================================================
// 初期表示
// ============================================================
const paramCard = cardFromParam();
const paramPage = PARAMS.get('p');

if (paramCard) {
	renderResult(paramCard);
} else if (paramPage === 'loading') {
	showSection(secLoading); // 確認用：自動遷移しない
} else {
	setTimeout(() => {
		secStart.querySelectorAll('.fadeInUp, .fadeIn').forEach((el) => el.classList.add('active'));
	}, 50);
}
